/* EasyUSA mega menu — pairs with snippets/easyusa-mega-menu.liquid.
   Panels + scrim move to <body> so position:fixed isn't trapped by a header
   ancestor. Listeners attach directly to elements (no document-level
   delegation — Horizon's view transitions swallow delegated clicks). */
(function () {
  if (window.__euMegaInit) return;
  window.__euMegaInit = true;

  var OPEN_DELAY = 80;
  var CLOSE_DELAY = 280;

  function init(root) {
    if (root.__euMega) return;
    root.__euMega = true;

    var bar = root.querySelector('.eu-mega__bar');
    var ind = root.querySelector('.eu-mega__ind');
    var anchor = root.closest('.eu-nav, .eu-header-min') || root;
    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-eu-mega-trigger]'));
    var panels = {};
    var scrim = document.createElement('div');
    scrim.className = 'eu-mega-scrim';
    document.body.appendChild(scrim);

    triggers.forEach(function (t) {
      var p = root.querySelector('#' + t.getAttribute('aria-controls'));
      if (!p) return;
      document.body.appendChild(p);
      panels[t.dataset.euMegaTrigger] = p;
      markSeason(p);
    });

    var current = null;
    var openTimer = null;
    var closeTimer = null;
    var openedAt = 0;

    function setTop() {
      var top = Math.max(0, Math.round(anchor.getBoundingClientRect().bottom));
      scrim.style.setProperty('--mm-top', top + 'px');
      Object.keys(panels).forEach(function (k) { panels[k].style.setProperty('--mm-top', top + 'px'); });
    }

    function slide(el, dark) {
      if (!ind || !el) return;
      var br = root.getBoundingClientRect();
      var r = el.getBoundingClientRect();
      ind.style.width = r.width + 'px';
      ind.style.height = r.height + 'px';
      ind.style.transform = 'translate(' + (r.left - br.left) + 'px,' + (r.top - br.top) + 'px)';
      ind.classList.add('is-on');
      ind.classList.toggle('is-dark', !!dark);
    }
    function resetInd() {
      if (!ind) return;
      if (current) slide(current, true);
      else ind.classList.remove('is-on', 'is-dark');
    }

    function open(t) {
      clearTimeout(closeTimer);
      if (current === t) return;
      var switching = !!current;
      if (current) hide(current);
      current = t;
      openedAt = Date.now();
      var p = panels[t.dataset.euMegaTrigger];
      setTop();
      t.setAttribute('aria-expanded', 'true');
      p.classList.toggle('is-switch', switching);
      p.hidden = false;
      scrim.classList.add('is-on');
      slide(t, true);
    }
    function hide(t) {
      t.setAttribute('aria-expanded', 'false');
      var p = panels[t.dataset.euMegaTrigger];
      if (p) { p.hidden = true; resetPreview(p); }
    }
    function close() {
      clearTimeout(openTimer);
      if (current) hide(current);
      current = null;
      scrim.classList.remove('is-on');
      resetInd();
    }
    function scheduleClose() {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(close, CLOSE_DELAY);
    }
    function keep() { clearTimeout(closeTimer); }

    triggers.forEach(function (t) {
      t.addEventListener('click', function () {
        // A click right after a hover-open is the same intent — keep it open.
        if (current === t) { if (Date.now() - openedAt > 600) close(); }
        else open(t);
      });
      t.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse') return;
        keep();
        clearTimeout(openTimer);
        slide(t, true);
        openTimer = setTimeout(function () { open(t); }, current ? 0 : OPEN_DELAY);
      });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' && current === t) {
          e.preventDefault();
          var first = panels[t.dataset.euMegaTrigger].querySelector('a');
          if (first) first.focus();
        }
      });
    });

    // Plain links + buttons in the bar: move the pill, close any open panel.
    Array.prototype.forEach.call(root.querySelectorAll('.eu-mega__link, .eu-mega__btn'), function (a) {
      a.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(openTimer);
        if (current) scheduleClose();
        if (a.classList.contains('eu-mega__link')) slide(a, false);
      });
    });

    bar.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      clearTimeout(openTimer);
      if (current) scheduleClose(); else resetInd();
    });
    bar.addEventListener('pointerenter', keep);

    Object.keys(panels).forEach(function (k) {
      var p = panels[k];
      p.addEventListener('pointerenter', keep);
      p.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') scheduleClose(); });
      p.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { var t = current; close(); if (t) t.focus(); }
      });
      p.addEventListener('focusout', function (e) {
        var to = e.relatedTarget;
        if (to && (p.contains(to) || root.contains(to))) return;
        close();
      });
      wirePreview(p);
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && current) { var t = current; close(); t.focus(); }
    });
    scrim.addEventListener('click', close);

    window.addEventListener('scroll', function () { if (current) setTop(); }, { passive: true });
    window.addEventListener('resize', function () { if (current) { setTop(); slide(current, true); } else resetInd(); });
  }

  // Northern-hemisphere retail calendar: Mar–Aug buys summer, Sep–Feb fall & winter.
  function currentSeason() {
    var m = new Date().getMonth() + 1;
    return m >= 3 && m <= 8 ? 'summer' : 'winter';
  }
  // Moves the in-season group to the first column and tags it "In season".
  function markSeason(p) {
    var g = p.querySelector('.eu-mega__group[data-season="' + currentSeason() + '"]');
    if (!g) return;
    g.classList.add('is-in-season');
    var chip = document.createElement('span');
    chip.className = 'eu-mega__chip';
    chip.textContent = 'In season';
    g.querySelector('.eu-mega__group-title').appendChild(chip);
  }

  // Hovering a category swaps the preview card to that collection's photo.
  function wirePreview(p) {
    var pv = p.querySelector('[data-eu-mega-preview]');
    if (!pv) return;
    var img = pv.querySelector('img');
    var tag = pv.querySelector('small');
    var title = pv.querySelector('b');
    var sub = pv.querySelector('.eu-mega__preview-sub');
    var defHref = pv.getAttribute('href');
    var shown = null;
    var defSeason = p.querySelector('.eu-mega__group[data-season="' + currentSeason() + '"]') ? currentSeason() : '';
    if (defSeason) pv.dataset.season = defSeason;
    var swap = null;
    var back = null;

    function show(src, href, t, s, label, season) {
      clearTimeout(back);
      if (shown === href) return;
      shown = href;
      if (season) pv.dataset.season = season; else delete pv.dataset.season;
      tag.textContent = label;
      title.textContent = t;
      sub.textContent = s;
      pv.setAttribute('href', href);
      if (!img) return;
      clearTimeout(swap);
      if (!src) return;
      if (img.getAttribute('src') === src) { img.hidden = false; return; }
      img.classList.add('is-out');
      swap = setTimeout(function () {
        img.onload = function () { img.classList.remove('is-out'); };
        img.hidden = false;
        img.src = src;
        if (img.complete) img.classList.remove('is-out');
      }, 140);
    }
    p.__euMegaReset = function () {
      show(img ? img.dataset.defaultSrc : '', defHref, title.dataset.default, sub.dataset.default, tag.dataset.default, defSeason);
    };
    Array.prototype.forEach.call(p.querySelectorAll('.eu-mega__cat'), function (a) {
      function go() {
        show(a.dataset.img || '', a.getAttribute('href'), a.dataset.title, a.dataset.count ? a.dataset.count + ' styles' : '', 'Preview', a.dataset.season);
      }
      a.addEventListener('pointerenter', go);
      a.addEventListener('focus', go);
    });
    var cols = p.querySelector('.eu-mega__cols');
    if (cols) cols.addEventListener('pointerleave', function () {
      clearTimeout(back);
      back = setTimeout(p.__euMegaReset, 600);
    });
  }
  function resetPreview(p) { if (p.__euMegaReset) p.__euMegaReset(); }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-eu-mega]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
